import FinanceBody from "../features/finance/FinanceBody";

const FinancePage = () => {
    return (
        <>
            <FinanceBody />
        </>
    )
}

export default FinancePage